import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';
import { Input } from '@/ui';

export const StyledInput = styled(Input)`
  ${pickThemeFontStyles('14', '22', 'BOLD')};
  height: 2.85rem;
`;

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1.5rem;
  max-width: 32rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('14', '16')};
    margin-bottom: 1.5rem;
  }
`;

export const StyledItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  gap: 0.5rem;
`;

export const StyledLabel = styled.div`
  ${pickThemeFontStyles('14', '16')};
`;

export const StyledValue = styled.div`
  ${pickThemeFontStyles('14', '16', 'SEMI_BOLD')};
  display: flex;
  gap: 0.125rem;
`;

export const StyledCircle = styled.div`
  display: flex;
  height: 0.5rem;
  width: 0.5rem;
  border-radius: 0.25rem;
  background-color: ${COLORS.BLACK};
`;
